exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".textInput-module-error{border:2px solid #992631 !important}.textInput-module-error_label{color:#992631 !important}", ""]);

// Exports
exports.locals = {
	"error": "textInput-module-error",
	"error_label": "textInput-module-error_label"
};